import styled from "styled-components";

export const StyledSection8 = styled.div`
  .section8-container {
    .section8-container-header {
      display: flex;
      flex-flow: row nowrap;
      gap: 16px;
      padding: 0 0 10px 0;
      & > button {
        min-width: 68px;
        font-size: 14px;
        outline: none;
        padding: 6px 10px;
        display: flex;
        gap: 4px;
        border: 1px solid #4679cc;
        border-radius: 4px;
        justify-content: center;
        align-items: center;
        &:hover:not(.disabled) {
          cursor: pointer;
          opacity: 0.8;
        }
      }

      .search-btn {
        background-color: #4679cc;
        color: #f0f0f0;
      }
    }

    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
    padding: 32px 0;
  }

  .pothole-table {
    width: 100%;
    border: 1px solid #e4e6ed;
    border-collapse: collapse;
    background-color: #fff;
  }

  .pothole-table thead th {
    height: 48px;
    font-size: 14px;
    vertical-align: middle;
    font-weight: 400;
    color: #333;
    background-color: #fafafb;
    border-bottom: 1px solid #dcdfe6;
  }

  .pothole-table tbody th,
  .pothole-table tbody td {
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid #eceff4;
  }

  .pothole-table tbody th {
    text-align: left;
    background-color: #f9fafc;
    white-space: nowrap;
  }

  .pothole-table tbody td {
  }

  .pothole-table tbody tr:nth-child(even) {
    background-color: #fbfcff;
  }

  .pothole-table tbody tr:hover {
    background-color: #f2f6ff;
  }
`;
